export default [{
  path: '/admin/apply/staff/list',
  name: 'staffList',
  component: () => import('@/views/apply/staff/list/index'),
  meta: {
    title: '人员管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/staff/role/list',
  name: 'staffRoleList',
  component: () => import('@/views/apply/staff/role/list/index'),
  meta: {
    title: '角色管理',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/staff.js